import { boolean, literal, nullable, object } from 'superstruct';
import { ListResourceDto } from '@arc/shared/util-data';
import { arcApiSchema } from '@arc/shared/util-route-schema';
import { parsableInteger } from '@arc/shared/util-superstruct';
import { AddArcRoleDto } from './add-arc-roles.dto';
import { EditArcRoleBaseMemberDto } from './base-member/edit-arc-role-base-member.dto';
import { ViewArcRoleBaseMemberDto } from './base-member/view-arc-role-base-member.dto';
import { EditArcRoleDto } from './edit-arc-roles.dto';
import { ListArcRolesQueryDto } from './list-arc-roles-query.dto';
import { ViewArcGroupImportDto } from './view-arc-group-import.dto';
import { ViewArcGroupDto } from './view-arc-groups.dto';
import { ViewArcRoleDto, ViewArcRoleListDto } from './view-arc-roles.dto';
const p = arcApiSchema.prefix('arc-roles');
const g = arcApiSchema.prefix('arc-groups');
export const ListArcRoles = p.get('', {
  req: object({
    query: ListArcRolesQueryDto
  }),
  res: ListResourceDto(ViewArcRoleListDto)
});
export const GetArcRole = p.get(':arcRoleId', {
  req: object({
    params: object({
      arcRoleId: parsableInteger()
    })
  }),
  res: ViewArcRoleDto
});
export const AddArcRole = p.post('', {
  req: object({
    body: AddArcRoleDto
  }),
  res: ViewArcRoleDto
});
export const EditArcRole = p.patch(':arcRoleId', {
  req: object({
    params: object({
      arcRoleId: parsableInteger()
    }),
    body: EditArcRoleDto
  }),
  res: ViewArcRoleDto
});
export const ArchiveArcRole = p.post(':arcRoleId/archive', {
  req: object({
    params: object({
      arcRoleId: parsableInteger()
    })
  }),
  res: literal(undefined)
});
export const UnarchiveArcRole = p.post(':arcRoleId/unarchive', {
  req: object({
    params: object({
      arcRoleId: parsableInteger()
    })
  }),
  res: literal(undefined)
});
export const StartArcRoleImport = p.post('import-roles', {
  req: object({}),
  res: literal(undefined)
});
export const GetArcRoleImportStatus = p.get('import-roles/status', {
  req: object({}),
  res: object({
    running: boolean()
  })
});
const b = arcApiSchema.prefix('arc-roles-base');
export const GetArcRoleBaseMember = b.get('', {
  req: object(),
  res: nullable(ViewArcRoleBaseMemberDto)
});
export const EditArcRoleBaseMember = b.put('', {
  req: object({
    body: EditArcRoleBaseMemberDto
  }),
  res: nullable(ViewArcRoleBaseMemberDto)
});
export const ListArcGroups = g.get('', {
  req: object({}),
  res: ListResourceDto(ViewArcGroupDto)
});
export const GetArcGroupImport = g.get('import', {
  req: object({}),
  res: nullable(ViewArcGroupImportDto)
});